module.exports = __webpack_public_path__ + "static/media/Logo Vector Rojo.a11c22aa.png";